import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {useLocation, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getDetailData, getTableColumns, getTableData} from "../../models/orderModel";
import {fetchOrderById} from "../../store/order-slice";
import Detail from "../../components/common/detail/Detail";
import Table from "../../components/common/table/Table";

const OrderDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {items, fetchByIdStatus, error} = useSelector(state => state.order);

    useEffect(() => {
        if (params.orderId) {
            dispatch(fetchOrderById({...userRole, orderId: params.orderId}));
        }
    }, [dispatch, params.orderId, userRole])

    const item = items.find(item => item.id === params.orderId);
    const products = item?.items || [];

    const detailData = getDetailData({item});
    const tableColumns = getTableColumns();
    const tableData = getTableData({items: products});

    // Define fallback URL if no state is present
    const stateUrl = location.state?.from;
    return (
        <>
            <SubHeader title="Order Details">
                <Button to={stateUrl}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" &&
                    <>
                        <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>

                        <h6 className="mt-4">Order Items</h6>
                        <Table className="mobile-responsive" columns={tableColumns} data={tableData}/>
                    </>
                }
            </div>
        </>
    )
}

export default OrderDetail;